package com.essntl.features.supplier.data.supabase

import com.essntl.core.supabase.SupabaseDataSource
import io.github.jan.supabase.SupabaseClient
import org.koin.core.annotation.Single

@Single(binds = [SupplierSupabaseDataSource::class])
internal class SupplierSupabaseDataSource(
    override val supabaseClient: SupabaseClient,
) : SupabaseDataSource<SupplierDto> {
    override val tableName: String = "supplier"
}
